import storageService from './storageService';

export default storageService;
